<template>
    <require from="../../parent-child-select/parent-child-select"></require>
    <parent-child-select
            items.bind="selectedObjectService.selectedObject.delete_right"
            objecttypetoadd.bind="'delete_right'"
            sortable.bind="'true'"
    >
    </parent-child-select>
</template>
